<template>
    <EditWindow heading="Edit instructor" :name="full_name(instructor.user)" @close="emit('close')">

        <EditSection title="Account">
            <EditAccount :owner="instructor"/>
        </EditSection>

        <EditSection title="Pay">
            <EditField :object="instructor" field="hourly_rate" label="Hourly rate (MXN)" type="number" step="0.01"
                       hint="Paid per class hour. A group with its own rate overrides it."/>
            <EditField :object="instructor" field="hourly_rate_usd" label="Hourly rate (USD)" readonly :display="usd"
                       hint="Calculated from the MXN rate (÷ 20)."/>
            <EditField :object="instructor" field="payment_method" label="Payment method" :suggestions="payment_methods"/>
        </EditSection>

        <EditSection title="Classes">
            <EditField :object="instructor" field="link" label="Class link" :href="web_link" wide
                       hint="The meeting link for this teacher's classes. A group's own link takes priority."/>
            <EditField :object="instructor" field="calendar" label="Google Calendar ID" wide
                       hint="Shown as the weekly calendar on the teacher's dashboard."/>
        </EditSection>

        <EditSection title="Notes">
            <EditField :object="instructor" field="comments" label="Comments" type="textarea"/>
        </EditSection>

    </EditWindow>
</template>


<script setup>

    import {ref,onMounted} from 'vue'
    import EditWindow from '@/components/edit/EditWindow.vue'
    import EditSection from '@/components/edit/EditSection.vue'
    import EditField from '@/components/edit/EditField.vue'
    import EditAccount from '@/components/edit/EditAccount.vue'
    import {load_options,full_name,web_link} from '@/components/edit/helpers.js'

    defineProps({
        instructor:{type:Object,required:true},
    })
    const emit=defineEmits(['close'])

    let payment_methods=ref([])

    onMounted(async()=>{
        let options=await load_options()
        // Values that look like account numbers stay out: one teacher's bank details are not
        // a choice to offer on everyone else's form.
        payment_methods.value=(options.observed['Instructor.payment_method'] || [])
            .filter(method=>!/\d{6,}/.test(method))
    })

    function usd(value){
        if(value===null || value===undefined || value===''){
            return '—'
        }
        return `$${Number(value).toFixed(2)}`
    }

</script>
